<div class="stats-card mb-3">
  <app-row gutter="sm" class="stats-card__list">
    <app-col *ngFor="let status of statues; let i = index; let last = last;">
      <app-stats-card-dashboard [theme]="status.theme" [inverted]="status.inverted">
        <app-icon class="align-middle" [name]="status.icon"></app-icon>
        <span title class="flex align-center text-nowrap">
          <app-icon name="saudi-riyal" size="xs" class="mr-1"></app-icon>
          {{status.amount| number:'1.0-2'| mask:isMaskData }}
        </span>
        <span subtitle>{{ "invoices.InvoiceList.Enum.FleetInvoiceStatus." + status.status | translate }}</span>
        <span ribbon>{{status.count | number:'1.0-2'}}</span>
        <span *ngIf="last" subtitle-icon>
          <app-icon
            [matTooltip]="'sharedFeatures.StatusCard.NoteThatOverdueDays' | translate"
            matTooltipPosition="above"
            class="icon text-400 align-middle ml-1"
            name="bold-info-circle"
            size="xs"
          ></app-icon>
        </span>
      </app-stats-card-dashboard>
    </app-col>
  </app-row>
</div>
